import { useTranslate } from '../../../hooks';
import Core, { API_V2 } from '../../core';
import useGenericMutation from '../use-generic-mutation';

interface Props {
  id: string;
  url: string;
  params?: object;
  customInvalidateQueriesUrl?: string;
  msg?: string;
}

export const useUpdate = ({
  url,
  id,
  msg,
  customInvalidateQueriesUrl,
}: Props) => {
  const { translate } = useTranslate();
  const api = Core.getInstance().api();

  return useGenericMutation({
    func: (data) => api.put(`${API_V2}/${url}/${id}`, data),
    url,
    msg: msg ?? translate('updated-successfully'),
    customInvalidateQueriesUrl,
  });
};
